import { useState } from "react";
import { AlertCircle, CheckCircle2, Loader2, Send } from "lucide-react";
import { sendInvite, formatApiError } from "../../lib/api";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export const PartnerInvite = ({ inviterEmail }) => {
  const [partner, setPartner] = useState("");
  const [error, setError] = useState("");
  const [sentTo, setSentTo] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSentTo("");
    const value = partner.trim();
    if (!EMAIL_RE.test(value)) return setError("Please enter a valid email address.");
    setError("");
    setLoading(true);
    try {
      const { data } = await sendInvite(inviterEmail, value);
      setSentTo(data.status === "queued" ? `${value} — it may take a few minutes to arrive` : value);
      setPartner("");
    } catch (err) {
      const status = err.response?.status;
      if (status === 422) setError("Please enter a valid email address.");
      else if (!status || status >= 500) setError("We couldn't send that just now — please try again");
      else setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} noValidate data-testid="partner-invite-panel" className="mt-4 rounded-[1.5rem] bg-[#FDFBF7]/10 p-5 sm:p-6 backdrop-blur-md border border-[#FDFBF7]/15 fade-up">
      <label htmlFor="partner-email" className="block font-serif text-xl text-[#FDFBF7]">Invite your partner</label>
      <div className="mt-4 flex flex-col sm:flex-row gap-2 rounded-[1.5rem] sm:rounded-full bg-[#FDFBF7] p-1.5">
        <input
          id="partner-email"
          type="email"
          autoComplete="off"
          placeholder="partner@family.com"
          value={partner}
          onChange={(e) => { setPartner(e.target.value); if (error) setError(""); }}
          aria-invalid={!!error}
          data-testid="partner-invite-email-input"
          className="min-w-0 flex-1 rounded-full bg-transparent px-4 py-3 text-base text-[#2C221E] placeholder:text-[#8A7A72] outline-none"
        />
        <button type="submit" disabled={loading} data-testid="partner-invite-submit-button" className="btn-soft justify-center bg-transparent">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />} Send invite
        </button>
      </div>
      {error && (
        <p role="alert" data-testid="partner-invite-error-message" className="mt-3 flex items-center gap-2 text-sm font-medium text-[#FFB59A]">
          <AlertCircle className="h-4 w-4 shrink-0" /> {error}
        </p>
      )}
      {sentTo && (
        <p data-testid="partner-invite-success-message" className="mt-3 flex items-center gap-2 text-sm font-medium text-[#CFE3D5]">
          <CheckCircle2 className="h-4 w-4 shrink-0" /> Invite sent to {sentTo} — we hope they join you soon.
        </p>
      )}
    </form>
  );
};
